import {GPTypeItem} from "./gp-typeitem";

export class GPTypeStructure extends GPTypeItem {
    constructor(gst) {
        super();

        this.typeName = "GPTypeStructure"
        this.id = parseInt(gst["-id"]);
        this.type = gst["-tp"];
        this.name = gst["-nm"];
        this.image = gst['-img'];
        this.height = gst["-hi"];
        this.diameter = gst["-di"];
        this.scale = gst["-sc"];
        this.active = gst["-ac"];
        this.model3d = false;
        this.premium = gst["-pr"];
        this.package = gst["package"];
        this.relativeBaseOffset = gst["-rbo"];
        this.variants = gst["variants"];
        this.enabled = GPSettings.products[gst['package'] + "_database"] ? GPSettings.products[gst['package'] + "_database"].active : false;
        this.visible = true;
    }

    staticGetPathForImage () {
        var size;
        size = "b";
        return GPSettings.structuresAddr(this, false, size) + size + 'v4/'+this.image+'.webp';
    }

    staticGetPathForThumb () {
        var size = "s";
        return GPSettings.structuresAddr(this, true, size) + size + 'v4/'+this.image+'.webp';
    }
    
}